import React from "react";
import Lottie from 'react-lottie';
import animationData from '../../assets/loader/Loader.json';

const Spinner = ({size = 118}) => {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    return (
        <Lottie
            options={defaultOptions}
            height={size}
            width={size}
        />
    );
};

export default Spinner;